import type { CatalogQuery } from '@revelio/data-access';

export type CatalogResult = CatalogQuery['catalog'];

type CatalogColumn = CatalogResult['data']['cols'][number];
type CatalogColumnType = CatalogColumn['__typename'];
type CatalogColumnOf<T extends CatalogColumnType> = Extract<
  CatalogColumn,
  { __typename: T }
>;

const isColumnOf = <T extends CatalogColumnType>(
  column: CatalogColumn,
  type: T
): column is CatalogColumnOf<T> => column.__typename === type;

export const readCatalogColumn = <T extends CatalogColumnType>(
  catalog: CatalogResult,
  name: string,
  type: T
): CatalogColumnOf<T> => {
  const index = catalog.schema.cols.findIndex((col) => col.name === name);
  const column = catalog.data.cols[index];
  if (column === undefined) {
    throw new Error(`Catalog response has no ${name} column`);
  }
  if (!isColumnOf(column, type)) {
    throw new Error(
      `Catalog column ${name} is ${column.__typename}, expected ${type}`
    );
  }
  return column;
};

export const catalogValueAt = <T>(
  values: readonly T[],
  row: number,
  name: string
): T => {
  const value = values[row];
  if (value === undefined) {
    throw new Error(`Catalog column ${name} has no value for row ${row}`);
  }
  return value;
};
